import React from 'react'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import InputLabel from '@material-ui/core/InputLabel'

// @material-ui/icons
import PermIdentity from '@material-ui/icons/PermIdentity'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import Button from 'components/CustomButtons/Button.jsx'
import CustomInput from 'components/CustomInput/CustomInput.jsx'
import Clearfix from 'components/Clearfix/Clearfix.jsx'
import Card from 'components/Card/Card.jsx'
import CardBody from 'components/Card/CardBody.jsx'
import CardHeader from 'components/Card/CardHeader.jsx'
import CardIcon from 'components/Card/CardIcon.jsx'

import styles from 'assets/jss/material-dashboard-pro-react/views/userProfileStyles'

// general api
import { insertOne, updateOne } from '../../services/generalServiceAPI'
import DropdownUsers from '../Components/DropdownUsers'
import * as Utility from '../utility/utility'
import swal from 'sweetalert'

class UserGroupProfile extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      text: {
        title: 'Create Group',
        button: 'Create'
      },
      data: {
        tableName: 'userGroups',
        id: '',
        name: '',
        groupMembers: '',
        description: ''
      },
      dataState: {
        name: '',
        groupMembers: 'error'
      },
      dirty: false
    }

    this.registerClick = this.registerClick.bind(this)
    this.change = this.change.bind(this)
    this.handleDropdown = this.handleDropdown.bind(this)
  }

  change(event) {
    this.setState({
      data: { ...this.state.data, [event.target.id]: event.target.value }
    })
    if (!this.state.dirty) this.setState({ dirty: true })
  }

  registerClick() {
    if (this.state.data.name === '') {
      this.setState({ dataState: { name: 'error' } })
    }

    if (this.state.dirty) {
      if (Utility.noError(this.state.dataState)) {
        const insertOrModify = data => (data.id !== '' ? updateOne(data) : insertOne(data))
        const { __typename, groupMembers, ...rest } = this.state.data
        const convertedMembers = groupMembers.map(m => ({
          id: m.value,
          name: m.label,
          weight: m.weight ? m.weight : 0
        }))
        insertOrModify({ groupMembers: convertedMembers, ...rest })
          .then(response => {
            Utility.handleResponseOfSaving(response, this.props.refetch)
          })
          .catch(e => swal(`General api throw error: ${e}`))
      } else swal('Please fix the error on the page first.')
    }

    this.props.hideEditProfile()
  }
  handleDropdown = name => value => {
    // console.log(value)
    const { data, dataState } = this.state
    data[name] = value
    dataState[name] = 'success'
    this.setState({
      dirty: true,
      data,
      dataState
    })
  }
  componentDidMount() {
    // don't allow the repopulate the editing record again, in case overriding the modified data with existing one
    const { groupMembers, id, name, description } = this.props.data
    let convertedMembers

    // if there is id passed down here, will update, otherwise means to create
    if (id !== '' && id !== this.state.data.id) {
      convertedMembers = groupMembers.map(m => ({
        value: m.id,
        label: m.name,
        weight: m.weight
      }))
      this.setState({
        text: {
          title: 'Update Group',
          button: 'Update'
        },
        data: {
          ...this.state.data,
          id,
          name,
          description,
          groupMembers: convertedMembers
        }
      })
    }
  }

  render() {
    const { classes } = this.props
    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <PermIdentity />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  {this.state.text.title} <small />
                </h4>
              </CardHeader>
              <CardBody>
                <form>
                  {/**   name*/}
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        success={this.state.dataState.nameState === 'success'}
                        error={this.state.dataState.nameState === 'error'}
                        labelText="UserGroup Name"
                        id="name"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          disabled: false,
                          value: this.state.data.name,
                          onChange: event => this.change(event),
                          type: 'text'
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <DropdownUsers
                        id="groupMembers"
                        onChange={this.handleDropdown('groupMembers')}
                        loose
                        helperText={'Choose members ...'}
                        value={this.state.data.groupMembers}
                        isMulti
                      />
                    </GridItem>
                  </GridContainer>

                  {/* abot */}
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <InputLabel style={{ color: '#AAAAAA' }}>Briefs</InputLabel>
                      <CustomInput
                        // labelText="Anything you want to say about this userGroup."
                        id="description"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          multiline: true,
                          value: this.state.data.description,
                          onChange: event => this.change(event),
                          rows: 5
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <Button color="rose" className={classes.updateProfileButton} onClick={this.registerClick}>
                    {this.state.text.button}
                  </Button>
                  <Clearfix />
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        {Utility.jsonPP(this.state)}
      </div>
    )
  }
}

export default withStyles(styles)(UserGroupProfile)
